



import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const About = () => {
  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/*  HERO SECTION  */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        {/* Background Image with Overlay */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&q=80')`,
          }}
        />
        {/* Dark Blue Overlay */}
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        {/* Content */}
        <div className="relative z-10 text-center px-4 sm:px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 sm:mb-8"
          >
            About Us
          </motion.h1>
          
          {/* Breadcrumb Buttons */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Home
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <span className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold text-sm sm:text-base">
              About Us
            </span>
          </motion.div>
        </div>
      </section>

     
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          {/* Top Content - Title and Text */}
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 mb-8 sm:mb-12">
            {/* Left - Title */}
            <div>
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="text-[#39a5d3] font-semibold text-base sm:text-lg mb-2"
              >
                About Us
              </motion.p>
              
              <motion.h2 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#19354a]"
              >
                Explore Docmize –<br />
                Your Healthcare Digital Growth Partner
              </motion.h2>
            </div>

            {/* Right - Content */}
            <div>
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4"
              >
                Docmize is committed to delivering compelling, tailor-made Growth Ecosystem solutions specifically designed for healthcare professionals and medical practices. We promise to assist you in taking advantage of Growth Ecosystem opportunities to grow your patient base, enhance your online presence, and build lasting trust with your community. Our enthusiastic and passionate team of healthcare marketing specialists is devoted to finding new and inventive ways to maximize patient engagement, all while securing appointments and driving practice growth.
              </motion.p>
              
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="text-sm sm:text-base text-gray-700 leading-relaxed"
              >
                We pride ourselves on being amongst the top agencies that are end-to-end providers of Growth Ecosystem services for doctors and healthcare providers. So whether you are searching for a comprehensive SEO strategy, a patient-converting website, or campaigns that fuel practice growth, trust us to find the right way for bringing more patients to your doorstep.
              </motion.p>
            </div>
          </div>

          {/* Images Row - Mobile Optimized */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-0">
            {/* Building Image - Bottom Right Cut */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="relative overflow-hidden rounded-lg sm:rounded-none"
              style={{
                clipPath: window.innerWidth >= 640 ? 'polygon(0 0, 100% 0, 100% 75%, 0 100%)' : 'none'
              }}
            >
              <img 
                src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80" 
                alt="Docmize Office Building"
                className="w-full h-[300px] sm:h-[450px] object-cover"
              />
            </motion.div>

            {/* Team Image - Top Left Cut */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative overflow-hidden rounded-lg sm:rounded-none sm:-ml-16"
              style={{
                clipPath: window.innerWidth >= 640 ? 'polygon(0 25%, 100% 0, 100% 100%, 0 100%)' : 'none'
              }}
            >
              <img 
                src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80" 
                alt="Docmize Team"
                className="w-full h-[300px] sm:h-[450px] object-cover"
              />
            </motion.div>
          </div>

        </div>
      </section>

      {/*  WHAT OUR CLIENTS VALUE MOST  */}
      <section className="py-12 sm:py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          {/* Section Header */}
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8 sm:mb-12"
          >
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-2">
              What Our Healthcare Clients Value Most
            </h2>
            <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#39a5d3]">
              ABOUT US
            </h3>
            <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto mt-4 sm:mt-6 leading-relaxed px-4">
              Offering a comprehensive suite of healthcare-focused Growth Ecosystem services, Docmize is uniquely positioned as one of the leaders in medical practice growth. Our diverse clientele of doctors, clinics, and healthcare providers across different specialties is a testament to our excellence and dedication to healthcare marketing.
            </p>
          </motion.div>

          {/* Three Cards - Mobile Optimized */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            
            {/* Card 1 - Experienced Team */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="bg-white rounded-2xl p-6 sm:p-8 border border-gray-200 hover:shadow-xl transition-all duration-300 text-center"
            >
              <div className="flex justify-center mb-4 sm:mb-6">
                <div className="w-20 h-20 sm:w-24 sm:h-24 bg-[#f7d794] rounded-full flex items-center justify-center">
                  <img 
                    src="/images/brand8.png" 
                    alt="Experienced Team"
                    className="w-12 h-12 sm:w-14 sm:h-14 object-contain"
                  />
                </div>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#19354a] mb-3 sm:mb-4">Healthcare Marketing Experts</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                With specialized experience in medical marketing, we have a well-seasoned team that understands the unique challenges and opportunities in healthcare. We're ready to help grow your practice with compliant, effective strategies.
              </p>
            </motion.div>

            {/* Card 2 - Quick Turnaround Time */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white rounded-2xl p-6 sm:p-8 border border-gray-200 hover:shadow-xl transition-all duration-300 text-center"
            >
              <div className="flex justify-center mb-4 sm:mb-6">
                <div className="w-20 h-20 sm:w-24 sm:h-24 bg-[#c4b5a4] rounded-full flex items-center justify-center">
                  <img 
                    src="/images/brand9.png" 
                    alt="Quick Turnaround Time"
                    className="w-12 h-12 sm:w-14 sm:h-14 object-contain"
                  />
                </div>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#19354a] mb-3 sm:mb-4">Fast Patient Acquisition</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                At Docmize, we understand that every day without new patients impacts your practice. Our team ensures quick campaign launches and rapid optimization to start bringing qualified patients to your clinic immediately.
              </p>
            </motion.div>

            {/* Card 3 - Transparency */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="bg-white rounded-2xl p-6 sm:p-8 border border-gray-200 hover:shadow-xl transition-all duration-300 text-center sm:col-span-2 lg:col-span-1"
            >
              <div className="flex justify-center mb-4 sm:mb-6">
                <div className="w-20 h-20 sm:w-24 sm:h-24 bg-[#b8d4ce] rounded-full flex items-center justify-center">
                  <img 
                    src="/images/brand10.png" 
                    alt="Transparency"
                    className="w-12 h-12 sm:w-14 sm:h-14 object-contain"
                  />
                </div>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#19354a] mb-3 sm:mb-4">Transparency & HIPAA Compliance</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                We are advocates of transparency and medical compliance. We follow healthcare marketing regulations and have pledged to maintain the same ethical principles with all our clients, building trust and protecting patient privacy.
              </p>
            </motion.div>

          </div>
        </div>
      </section>

      {/* Meet the Team Section */}
<section 
  className="relative py-16 overflow-hidden bg-white"
>
  <div className="max-w-7xl mx-auto px-6 relative z-10">
    <div className="grid lg:grid-cols-2 gap-12 items-center">
      
      {/* Left - Image */}
      <motion.div
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="relative"
      >
        <div className="relative max-w-md mx-auto">
          <div 
            className="rounded-2xl overflow-hidden shadow-2xl"
          >
            <img
              src="/images/37.png"
              alt="Meet the Docmize Team"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </motion.div>

      {/* Right - Content */}
      <motion.div
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        <p 
          className="text-[#39a5d3] font-semibold text-lg mb-3"
        >
          Meet the Team
        </p>
        
        <h2 
          className="text-3xl lg:text-4xl font-bold text-[#19354a] mb-6 leading-tight"
        >
          Docmize, Your Healthcare Digital Partners
        </h2>

        <div className="space-y-4 text-base leading-relaxed text-gray-800">
          <p>
            At the heart of Docmize is a team of passionate healthcare marketing experts who 
            believe in the power of merging medical expertise with digital innovation. We're your 
            partners in success and the architects of campaigns that leave a lasting impact.
          </p>
          <p>
            From SEO specialists and content creators to web developers and patient acquisition experts, 
            every member of our team is dedicated to one mission: helping your practice thrive. We don't 
            just deliver services—we build lasting relationships and celebrate your success as our own.
          </p>
        </div>

        {/* Decorative Line */}
        <div 
          className="mt-6 w-24 h-1 bg-[#E85A2C] rounded-full"
        />
      </motion.div>

    </div>
  </div>
</section>


      {/*  OUR OPEN INVITATION SECTION  */}
      <section className="relative overflow-hidden">
        <div className="grid lg:grid-cols-2">
          
          {/* Left - Dark Blue Background Content */}
          <div className="bg-[#19354a] p-8 sm:p-12 lg:p-16 flex flex-col justify-center order-2 lg:order-1">
            <motion.h2 
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4 sm:mb-6"
            >
              Our Open<br />
              Invitation to You
            </motion.h2>
            
            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="text-sm sm:text-base text-white/90 leading-relaxed mb-3 sm:mb-4"
            >
              Step into our world of healthcare digital marketing. At any given time, you can connect with our team and experience the magic firsthand. Our workspace is where medical marketing strategies come to life – stop by and watch our talented healthcare marketers, designers, and SEO specialists craft campaigns that bring patients to your practice.
            </motion.p>
            
            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-sm sm:text-base text-white/90 leading-relaxed"
            >
              Don't be surprised if you're greeted with a warm cup of coffee and endless enthusiasm for growing your medical practice!
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="mt-6 sm:mt-8"
            >
              <Link 
                to="/contact" 
                className="inline-block px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
              >
                Schedule a Visit
              </Link>
            </motion.div>
          </div>

          {/* Right - Image */}
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative order-1 lg:order-2"
          >
            <img 
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80" 
              alt="Team Collaboration"
              className="w-full h-[300px] sm:h-[400px] lg:h-full lg:min-h-[500px] object-cover"
            />
          </motion.div>

        </div>
      </section>

      {/*  WHAT MAKES US DIFFERENT  */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          {/* Section Header */}
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8 sm:mb-12"
          >
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a]">
              What makes Us Different from others
            </h2>
         
          </motion.div>

          {/* Three Cards - Mobile Optimized */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            
            {/* Card 1 - Experienced Team */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="mb-4 sm:mb-6">
                <img 
                  src="/images/brand11.png" 
                  alt="Experienced Team"
                  className="w-16 h-16 sm:w-20 sm:h-20 object-contain"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#19354a] mb-3 sm:mb-4">Healthcare Marketing Specialization</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Unlike general marketing agencies, we exclusively focus on healthcare. Our team understands medical terminology, patient psychology, and healthcare compliance, bringing unmatched expertise to every campaign we create for doctors and clinics.
              </p>
            </motion.div>

            {/* Card 2 - Quick Turnaround Time */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="mb-4 sm:mb-6">
                <img 
                  src="/images/brand12.png" 
                  alt="Quick Turnaround Time"
                  className="w-16 h-16 sm:w-20 sm:h-20 object-contain"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#19354a] mb-3 sm:mb-4">Patient-Centric Strategies</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                We don't just drive traffic – we attract the right patients. Our strategies are built around patient needs, local search behavior, and appointment conversions, ensuring every campaign delivers real practice growth and patient satisfaction.
              </p>
            </motion.div>

            {/* Card 3 - Transparency */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300 sm:col-span-2 lg:col-span-1"
            >
              <div className="mb-4 sm:mb-6">
                <img 
                  src="/images/brand13.png" 
                  alt="Transparency"
                  className="w-16 h-16 sm:w-20 sm:h-20 object-contain"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#19354a] mb-3 sm:mb-4">Data-Driven Results</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                We track what matters most – new patient appointments, consultation bookings, and practice revenue. With transparent reporting and analytics, you'll always know your ROI and how your marketing investment translates to practice growth.
              </p>
            </motion.div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;

